<script setup lang="ts">
import { cn } from "~/lib/utils";

type DasboardSidebarItemProps = {
  icon: string;
  title: string;
  href: string;
};

interface Events {
  click: [];
}

const props = defineProps<DasboardSidebarItemProps>();
const emit = defineEmits<Events>();

const route = useRoute();
const isActive = computed(() => {
  return route.path.split("/")[1] === props.href.split("/")[1];
});
</script>

<template>
  <Tooltip>
    <TooltipTrigger as-child>
      <NuxtLink
        :class="
          cn(
            'flex w-full items-center gap-2 rounded bg-primary px-4 py-3 text-white/80 transition-colors',
            !isActive && 'hover:bg-background-alt/10 active:bg-primary',
            isActive && 'bg-background-alt text-primary',
          )
        "
        :to="href"
        @click="emit('click')"
      >
        <Icon :name="icon" class="text-xl lg:text-sm" />
        <span class="mt-[3px] text-sm lg:inline">{{ title }}</span>
      </NuxtLink>
    </TooltipTrigger>
    <TooltipContent class="lg:hidden">{{ title }}</TooltipContent>
  </Tooltip>
</template>
